import { gql } from 'apollo-boost';

export const MODIFY_CART_DOCTOR = gql`
  mutation doModifyCartDoctor($id: ID!, $data: CartDoctorInput!) {
    modifyCartDoctor(id: $id, data: $data) {
      id
      doctorId
      firstName
      lastName
      company
      address1
      address2
      city
      zip
      state
      country
      phone
    }
  }
`;
